import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CollectionPage from "@/pages/CollectionPage";
import LoginPage from "@/pages/LoginPage";
import InsuranceReportPage from "@/pages/InsuranceReportPage";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Disc3 } from "lucide-react";

function LoadingShell() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background bg-grain" data-testid="auth-loading">
            <Disc3 className="w-10 h-10 text-primary vinyl-spin" strokeWidth={1.5} />
        </div>
    );
}

function Protected({ children }) {
    const { status } = useAuth();
    if (status === "checking") return <LoadingShell />;
    if (status !== "in") return <Navigate to="/login" replace />;
    return children;
}

function LoginGate() {
    const { status } = useAuth();
    if (status === "checking") return <LoadingShell />;
    if (status === "in") return <Navigate to="/" replace />;
    return <LoginPage />;
}

function App() {
    return (
        <div className="App min-h-screen">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<LoginGate />} />
                        <Route
                            path="/"
                            element={
                                <Protected>
                                    <div className="bg-grain min-h-screen">
                                        <CollectionPage />
                                    </div>
                                </Protected>
                            }
                        />
                        <Route
                            path="/report"
                            element={
                                <Protected>
                                    <InsuranceReportPage />
                                </Protected>
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            <Toaster position="top-right" richColors />
        </div>
    );
}

export default App;
